<template>
<div>
    <HeadDetailsGama :titleHead="'Detalhe consulta de vendas'"></HeadDetailsGama>
            <div id="body-details" class="mt-4 ml-2">
                    <p  class="ml-3 subtitle">Forma de Pagamento: {{selectedComissao.proposta.formaPagamento}}</p>
                    <div class="corpo-forma d-flex">
                        <div class="imovel-entrada">
                            <p class="label-details">Valor Total do Imóvel</p>
                            <input class="input-details" disabled v-model="selectedComissao.proposta.valorTotalFormatado">
                        </div>
                        <div class="imovel-entrada">
                            <p class="label-details">Entrada 10%</p>
                            <input disabled class="input-details" v-model="selectedComissao.proposta.valorTotalFormatado">
                        </div>
                        <div class="reajuste">
                            <p class="label-details">10% na Entrega Corrigido pelo Reajuste</p>
                            <input disabled class="input-details" v-model="selectedComissao.proposta.valorTotalFormatado">
                        </div>
                    </div>
                     <div class="corpo-forma margin d-flex">
                        <div class="imovel-entrada">
                                <p class="label-details">Informação do Pagamento</p>
                                <input disabled class="input-details" v-model="selectedComissao.proposta.formaPagamento">
                        </div>
                        <div class="imovel-entrada">
                                <p class="label-details">Quantidade de Parcelas</p>
                                <input disabled class="input-details" v-model="selectedComissao.proposta.numeroParcelas">
                        </div>
                        <div class="reajuste">
                                <p class="label-details">Parcelas Mensais Consecutivas com Reajuste Mensal</p>
                                <input disabled class="input-details" v-model="selectedComissao.proposta.valorMensalFormatado">
                        </div>
                        <div class="reajuste">
                                <p class="label-details">Parcelas Balões Anuais com Reajuste Mensal</p>
                                <input disabled class="input-details" v-model="selectedComissao.proposta.valorTotalFormatado">
                        </div>
                    </div>
            </div>
</div>
</template>

<script>
import ValueEnterprise from './valueEnterprise'
export default ValueEnterprise
</script>

<style scoped>
.imovel-entrada {
    width: 40%;
}
.margin {
    margin-top: 2rem;
}
.parcela-info {
    width: 25%;
}
.reajuste {
    width: 100%;
}
#details-board-value{
    margin-bottom: 45vh;
}
.corpo-forma{
    padding: 0 1rem 0 1rem;
    column-gap: 10px;
}
.subtitle{
    font-size: 18px;
    color: #008148;
    font-weight: bold;
    margin-bottom: 15px;
}

.input-details{
    width: 100%;
    height: 35px;
    background-color: #F1F1F1;
    border: 1px solid #D4D9DE;
    border-radius: 5px;
}

.label-details{
    margin-bottom: 0;
    font-size: 13px;
}

#card-details{
  height: 100%;
  background: white;
  margin-bottom: 2%;
}
</style>



// WEBPACK FOOTER //
// src/views/private/realestate/salesinquiry/components/valueenterprise/valueEnterprise.vue